/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocioConfiguracion } from '../../conexiones';
import IResolucionesFacturaciones from './entidades/resolucionesFacturaciones';

export default class ModeloResolucionesFacturaciones {
    public consultarResolucionesFacturaciones() {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocioConfiguracion.get('ResolucionesFacturaciones/ConsultarListaResolucionesFacturaciones')
        );
    }
    public crearResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocioConfiguracion.post('ResolucionesFacturaciones/GuardarResolucionesFacturaciones', resolucionesFacturaciones)
        );
    }
    public editarResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocioConfiguracion.put('ResolucionesFacturaciones/EditarResolucionesFacturaciones', resolucionesFacturaciones)
        );
    }
    public eliminarResolucionesFacturaciones(resolucionesFacturaciones: IResolucionesFacturaciones) {
        return manejadorRest<IRespuesta<IResolucionesFacturaciones>>(() =>
            negocioConfiguracion.delete('ResolucionesFacturaciones/EliminarResolucionesFacturaciones', resolucionesFacturaciones)
        );
    }
}
